export class DateUtils {
  static DaysShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  static DaysLong = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  static MonthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
  static MonthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];


  static showDate(date: Date, dateFormat: string): string {
    let str = '';
    let i = 0;
    while (i < dateFormat.length) {
      const ch0 = dateFormat.charAt(i);
      let ch = ch0;
      i++;
      while (i < dateFormat.length) {
        const ch1 = dateFormat.charAt(i);
        if (ch0 !== ch1) {
          break;
        }
        ch += ch1;
        i++;
      }


      switch (ch) {
        case 'YY':
          str += date.getFullYear() % 100;
          break;
        case 'YYYY':
          str += date.getFullYear();
          break;
        case 'M':
          str += date.getMonth() + 1;
          break;
        case 'MM':
          const MM = date.getMonth() + 1;
          if (MM < 10) {
            str += '0';
          }
          str += MM;
          break;
        case 'MMM':
          str += this.MonthsShort[date.getMonth()];
          break;

        case 'MMMM':
          str += this.MonthsLong[date.getMonth()];
          break;

        case 'D':
          str += date.getDate();
          break;
        case 'DD':
          const DD = date.getDate();
          if (DD < 10) {
            str += '0';
          }
          str += DD;
          break;
        case 'J': // (0-23)
          str += date.getHours();
          break;
        case 'JJ': // (0-23)
          const JJ = date.getHours();
          if (JJ < 10) {
            str += '0';
          }
          str += JJ;
          break;
        case 'H': // (1-24)
          let H = date.getHours();
          if (H === 0) {
            H = 24;
          }
          str += H;
          break;
        case 'HH': // (1-24)
          let HH = date.getHours();
          if (HH === 0) {
            HH = 24;
          }
          if (HH < 10) {
            str += '0';
          }
          str += HH;
          break;

        case 'A':
          str += (date.getHours() / 12 < 1) ? "AM" : "PM";
          break;

        case 'K': // (0-11)
          str += date.getHours() % 12;
          break;
        case 'L': // (1-12)
          let L = date.getHours() % 12;
          if (L === 0) {
            L = 12;
          }
          str += L;
          break;
        case 'N':
          str += date.getMinutes();
          break;
        case 'NN':
          const min = date.getMinutes();
          if (min < 10) {
            str += '0';
          }
          str += min;
          break;
        case 'S':
          str += date.getSeconds();
          break;
        case 'SS':
          const sec = date.getSeconds();
          if (sec < 10) {
            str += '0';
          }
          str += sec;
          break;

        case 'E':
          str += date.getDay();
          break;

        case 'EE':
          str += '0' + date.getDay();
          break;

        case 'EEE':
          str += this.DaysShort[date.getDay()];
          break;

        case 'EEEE':
          str += this.DaysLong[date.getDay()];
          break;

        default:
          str += ch;
          break;
      }
    }
    return str;
  }
}
